import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
export default {
    execute: async (data) => {
        const { submitBtn, entities } = data;
        const formRequest = makeFormRequest({ submitBtn });
        const response = await Request.post('/events/reorder', entities);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Events reordered successfully.`,
                onRedirect: '/events'
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
